import {useTranslation} from 'react-i18next';
import {TEticketSeat, TEticketSeatMap} from '../../../../redux/eTicket/eTicket.type';
import SeatTile from './SeatTile';
import * as css from './TicketSeatTiles.css';

interface TicketSeatTilesProps {
    seat?: TEticketSeat;
    seatMap?: TEticketSeatMap;
}

const SEAT_FIELDS: {key: keyof TEticketSeat; label: string; flexible?: boolean}[] = [
    // {key: 'gate', label: 'seatGate'}, // אין עדיין מקור נתונים ל'שער' ב-DB
    {key: 'section', label: 'seatBlock', flexible: true},
    {key: 'row', label: 'seatRow'},
    {key: 'seat', label: 'seatSeat'},
];

// A block (גוש) is often a name, so only plain whole numbers get grouped — '1500' → '1,500'.
function formatValue(value: string | number, language?: string) {
    return /^\d+$/.test(String(value)) ? Number(value).toLocaleString(language || undefined) : value;
}

function TicketSeatTiles({seat, seatMap}: TicketSeatTilesProps) {
    const {t, i18n} = useTranslation('eTicket');
    const hideBlock = Object.keys(seatMap?.area ?? {}).length === 1;

    const tiles = SEAT_FIELDS
        .filter(({key}) => !(hideBlock && key === 'section'))
        .map(({key, label, flexible}) => ({key, flexible, label: t(label), value: seat?.[key]}))
        .filter(({value}) => value != null && value !== '')
        .map(tile => ({...tile, value: formatValue(tile.value as string | number, i18n.language)}));

    if(!tiles.length) return null;

    return (
        <css.row data-cy="ticket-seat-tiles">
            {tiles.map(({key, label, value, flexible}) => (
                <SeatTile key={key} value={value} label={label} flexible={flexible} data-cy={`ticket-seat-tile-${key}`} />
            ))}
        </css.row>
    );
}

export default TicketSeatTiles;
